import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const updateByUser = async (
  state: IStore,
  clubId: string | number,
  userId: number,
  data: any
) => {
  const response = await request.patch(`${api.admin.clubs}${clubId}/memberships/${userId}`, data);

  if (response.error) {
    return { errors: { memberships: { msg: 'Error updating the player memberships.' } } };
  }

  const memberships = state.adminMemberships.memberships;

  const playerIndex = memberships.findIndex(membership => membership.id === userId);

  memberships[playerIndex] = response;

  return {
    adminMemberships: {
      memberships
    }
  };
};
